import editableData from "./siteEditable.json";

export const ctaPhone = {
  label: editableData.contactInfo.phoneDisplay,
  href: editableData.contactInfo.phoneHref
};

export const pageCtaContent = {
  home: {
    badge: "Counselling Enquiry",
    title: "Ready to start admission planning with practical clarity?",
    description:
      "Speak with TheCareerSpace to shape your next steps around profile fit, family priorities, and realistic options.",
    primaryCta: { label: "Start Counselling Discussion", to: "/contact" },
    secondaryCta: { label: "Explore Admission Pathways", to: "/colleges" }
  },
  about: {
    badge: "Speak With TheCareerSpace",
    title: "Need admission direction tailored to your family context?",
    description:
      "Connect with our counselling team for a calm, practical roadmap and clearly sequenced next steps.",
    primaryCta: { label: "Book a Counselling Call", to: "/contact" },
    secondaryCta: { label: "Talk to a Counsellor", to: "/contact" }
  },
  services: {
    badge: "Choose Your Admission Path",
    title: "Not sure which service track fits your situation best?",
    description:
      "Talk through your profile and we will help you choose the right starting pathway with confidence.",
    primaryCta: { label: "Talk to a Counsellor", to: "/contact" },
    secondaryCta: { label: "See Pathway Options", to: "/colleges" }
  },
  bachelorsIndia: {
    badge: "Bachelor's Counselling",
    title: "Need clarity on the right undergraduate direction after Class 12?",
    description:
      "Start with a counselling conversation and get structured guidance for your next admission steps.",
    primaryCta: { label: "Discuss Bachelor's Options", to: "/contact" },
    secondaryCta: { label: "Contact Counselling Team", to: "/contact" }
  },
  mastersIndia: {
    badge: "Master's Admissions Guidance",
    title: "Want a sharper postgraduate admission strategy?",
    description:
      "Work with TheCareerSpace to map specialization choices, college fit, and process flow with practical clarity.",
    primaryCta: { label: "Plan Master's Journey", to: "/contact" },
    secondaryCta: { label: "Contact Counselling Team", to: "/contact" }
  },
  mbbsIndia: {
    badge: "MBBS Counselling Support",
    title: "Planning MBBS in India and need reliable next-step clarity?",
    description:
      "Speak with TheCareerSpace for structured guidance aligned to student priorities and family confidence.",
    primaryCta: { label: "Book MBBS Counselling", to: "/contact" },
    secondaryCta: { label: "Contact Counselling Team", to: "/contact" }
  },
  mbbsAbroad: {
    badge: "MBBS Abroad Counselling",
    title: "Need practical guidance before committing to MBBS abroad?",
    description:
      "Talk through country and college-fit considerations in a calm, family-inclusive counselling discussion.",
    primaryCta: { label: "Start MBBS Abroad Discussion", to: "/contact" },
    secondaryCta: { label: "Contact Counselling Team", to: "/contact" }
  },
  colleges: {
    badge: "College Shortlisting Support",
    title: "Ready to convert this list into a meaningful shortlist?",
    description:
      "Connect with TheCareerSpace for profile-led shortlisting support across states, pathways, and priorities.",
    primaryCta: { label: "Start Shortlist Counselling", to: "/contact" },
    secondaryCta: { label: "Contact Counselling Team", to: "/contact" }
  },
  contact: {
    badge: "Admissions Enquiry",
    title: "Prefer to begin with a quick counselling-first conversation?",
    description:
      "Use the enquiry form or contact desk details and we will guide your next steps with clarity and care.",
    primaryCta: { label: "Go to Enquiry Form", href: "#enquiry-form" },
    secondaryCta: { label: "View College Pathways", to: "/colleges" }
  },
  faq: {
    badge: "Still Need Clarity?",
    title: "Talk through your admission questions with TheCareerSpace.",
    description:
      "If your concern is specific to your profile or family context, a counselling discussion can provide clearer direction than general answers.",
    primaryCta: { label: "Start Counselling", to: "/contact" },
    secondaryCta: { label: "View College Pathways", to: "/colleges" }
  }
};
